export default "__VITE_ASSET__GgZqeIiB__"